import jsep from 'jsep';

export const binaryOperators = ['+', '-', '*', '/'];

/**
 * Parse a term string and check if the membership values are all valid column names.
 * @param acceptedColumnNames list of column names that are accepted in the expression
 * @param expressionString expression string to parse
 * @throws if the expression is invalid or contains invalid column names
 * @throws if the expression contains unsupported operators or functions
 * @returns original string if valid, otherwise throws an error
 */
export function parseETLContrastTermExpression(acceptedColumnNames: string[], expressionString: string): any {
  function parseUnaryOperator(expr: jsep.Expression) {
    const unExpr = expr as jsep.UnaryExpression;
    recursiveEval(unExpr.argument);
  }

  function parseMemberExpression(expr: jsep.Expression) {
    const litExpr = expr as jsep.MemberExpression;
    if (litExpr.object.type !== 'Identifier') {
      throw `Member expression should be a column identifier`;
    }
    const colName = String(litExpr.object.name ?? '');
    if (!acceptedColumnNames.includes(colName)) {
      throw `Column "${colName}" is not a valid column name in the expression`;
    }
  }

  function parseBinaryOperator(expr: jsep.Expression) {
    const binExpr = expr as jsep.BinaryExpression;
    if (!binaryOperators.includes(binExpr.operator)) throw `Unsupported binary operator ${binExpr.operator}`;
    recursiveEval(binExpr.left);
    recursiveEval(binExpr.right);
  }

  function recursiveEval(expr: jsep.Expression): any {
    if (expr.type == 'BinaryExpression') return parseBinaryOperator(expr);
    if (expr.type == 'UnaryExpression') return parseUnaryOperator(expr);
    if (expr.type == 'Literal') return;
    if (expr.type == 'MemberExpression') return parseMemberExpression(expr);
    if (expr.type == 'Identifier') {
      throw 'Column identifiers should include a value member, e.g. "column.value"';
    }

    throw `Unsupported token type ${expr.type}`;
  }

  try {
    const parsedExpression = jsep(expressionString);
    recursiveEval(parsedExpression);
    return expressionString; // Return the original string if valid
  } catch (error) {
    throw `Invalid expression: ${String(error)}`;
  }
}
